export const ORGANIZATION_ADMINISTRATION_FEATURE = 'organizationAdministration';